// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function --experiment sessions-page-experiment --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeStringFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
// Note: The following attributes are automatically provided by the experiment provider
// and do not need to be passed as parameters: userEmail
export const useSessionsPageExperimentVariation = makeStringFlagValueHook('sessions-page-experiment');
//# sourceMappingURL=useSessionsPageExperimentVariation.js.map